import { Injectable } from '@angular/core';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { Appointment } from '../appointment';
import { Person } from '../models/person';
import { JwtAuthService } from '../../shared/services/auth/jwt-auth.service';
import { DateService } from '../../shared/services/date.service';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AppointmentsEntityService extends BaseEntityService<Appointment> {
  public lastAppointment: Appointment;

  constructor(
    httpClient: HttpClient,
    private dateService: DateService,
    private jwtAuthService: JwtAuthService,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, { singular: 'appointment', plural: 'appointments' },
      routerParamsService
    );
    this.nameId = 'appointmentId'
  }

  setLastAppointment(appointment: Appointment) {
    this.lastAppointment = appointment;
  }

  initAppointment(
    type: Appointment['type'],
    patient: Person,
  ): Observable<Appointment> {
    const professional = this.jwtAuthService.getUser();
    const startedAt = this.dateService.getUtcDateTime();
    const body = {
      startedAt,
      endedAt: null,
      type,
      notes: null,
      patient: {
        id: patient.id,
      },
      professional: {
        id: professional.id,
      },
    };
    return this.add(body);
  }

  endAppointment(appointment): Observable<Appointment> {
    const endedAt = this.dateService.getUtcDateTime();
    const body = { ...appointment, endedAt };
    return this.update(body);
  }

  updateNotes(
    notes: string,
    appointment: Appointment,
  ): Observable<Appointment> {
    const body = { ...appointment, notes };
    return this.update(body);
  }

  updateAppointment(appointment: Appointment): Observable<Appointment> {
    const { startedAtTime, endedAtTime } = appointment;
    let { startedAt, endedAt } = appointment;

    startedAt = this.dateService.setUtcDateTime(
      startedAt,
      startedAtTime.toString(),
    );
    endedAt = this.dateService.setUtcDateTime(endedAt, endedAtTime.toString());

    const body = { ...appointment, endedAt, startedAt };
    return this.update(body);
  }
}
